export default "__VITE_ASSET__DerfDERH__"